import type { 
  CreateWorkspaceRequest, 
  CreateWorkspaceResponse, 
  Workspace, 
  GetWorkspacesResponse, 
  ApiError 
} from './types';

/**
 * Server-safe API functions for workspace management
 */

/**
 * Get user's workspaces
 */
export async function getWorkspaces(): Promise<GetWorkspacesResponse> {
  const response = await fetch('/api/workspaces');
  const result = await response.json();

  if (!response.ok) {
    throw new Error(result.error || 'Failed to get workspaces');
  }

  return result;
}

/**
 * Create a new workspace
 */
export async function createWorkspace(data: CreateWorkspaceRequest): Promise<CreateWorkspaceResponse> {
  const response = await fetch('/api/workspaces/create', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  });

  const result = await response.json();

  if (!response.ok) {
    throw new Error(result.error || 'Failed to create workspace');
  }

  return result;
}

/**
 * Create a default workspace for a new user (race-condition safe)
 * Only creates if user doesn't already have workspaces
 */
export async function createDefaultWorkspace(data?: { name?: string; description?: string }): Promise<{
  workspace?: Workspace;
  created: boolean;
  message: string;
}> {
  const response = await fetch('/api/workspaces/create-default', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data || {}),
  });

  const result = await response.json();

  if (!response.ok) {
    throw new Error(result.error || 'Failed to create default workspace');
  }

  return result;
} 